import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { apiCall } from "../Apis/apiCall";
import { handleApiResponse, handleCustomResponse } from "../utils/response";
import Breadcrumb from "./Breadcrumb";

const AddPermission = () => {
  const [permissionKey, setPermissionKey] = useState("");
  const [description, setDescription] = useState("");
  const [moduleName, setModuleName] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleAddPermission = async () => {
    if (!permissionKey.trim() || !description.trim() || !moduleName.trim()) {
      handleCustomResponse("error", "All fields are required.");
      return;
    }

    setLoading(true);

    try {
      const payload = {
        permission_key: permissionKey,
        description,
        module_name: moduleName,
      };

      const response = await apiCall(
        "post",
        "/create-user-permission",
        payload,
        navigate
      );

      if (response?.data?.success) {
        const handleRes = response.data;
        handleApiResponse(handleRes, "success", "POST");
        // Reset form
        setPermissionKey("");
        setDescription("");
        setModuleName("");

        setTimeout(() => {
          navigate("/user-permissions"); // Or whatever route you use
        }, 2000);
      } else {
        handleCustomResponse("error", "Failed to add permission.");
      }
    } catch (error) {
      const handleErr = error.response?.data;
      handleApiResponse(handleErr, "Err", "POST");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Breadcrumb title="Add User Permissions" />

      <div className="card h-100 p-0 radius-12 overflow-hidden">

        <div className="card-body p-40">
          <form autoComplete="off">
            <div className="row">
              <div className="col-sm-6 mb-20">
                <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                  Permission Key <span className="text-danger-600">*</span>
                </label>
                <input
                  type="text"
                  className="form-control radius-8"
                  placeholder="e.g. add_users"
                  value={permissionKey}
                  onChange={(e) => setPermissionKey(e.target.value)}
                />
              </div>

              <div className="col-sm-6 mb-20">
                <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                  Module Name <span className="text-danger-600">*</span>
                </label>
                <input
                  type="text"
                  className="form-control radius-8"
                  placeholder="e.g. Users"
                  value={moduleName}
                  onChange={(e) => setModuleName(e.target.value)}
                />
              </div>

              <div className="col-sm-12 mb-20">
                <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                  Description <span className="text-danger-600">*</span>
                </label>
                <textarea
                  rows="3"
                  className="form-control radius-8"
                  placeholder="Permission to add back office users"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                ></textarea>
              </div>

              <div className="col-sm-12">
                <div className="d-flex justify-content-center gap-3 mt-24">
                  <Link
                    to="/user-permissions"
                    className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-11 radius-8 text-decoration-none"
                  >
                    Cancel
                  </Link>
                  <button
                    type="button"
                    className="btn btn-primary-600 text-md px-24 py-12 radius-8"
                    onClick={handleAddPermission}
                    disabled={loading}
                  >
                    {loading ? "Please wait..." : "Add Permission"}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      
    </div>
  );
};

export default AddPermission;
